import styled from "styled-components";
import { SectionSubtitle, SectionTitle } from "components/Style";
import { QUALIFICATIONS } from "appLauncher";

const QualificationSection = styled.section`
  padding: 80px 0;
  background-color: #f8f8f8;
`;

const QualificationContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 15px;
`;

// 标题已用全局SectionTitle

const QualificationItems = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(282px, 1fr));
  gap: 30px;
  place-items: center;
`;

const QualificationItem = styled.div`
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 282px;
  height: 164px;
  white-space: nowarp;
  background: linear-gradient(180deg, #f7fcfd 0%, #ffffff 100%);
`;

const QualificationIconPlaceholder = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 50%;
  margin-bottom: 15px;
  background: #e9ecf2;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const QualificationTitle = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  margin: 0 0 4px 0;
  line-height: 1.3;
  word-break: break-all;
  overflow: hidden;
`;

const QualificationSubtitle = styled.p`
  font-size: 0.92rem;
  color: #999;
  margin: 0;
  line-height: 1.3;
  word-break: break-all;
  overflow: hidden;
`;

export default function QualificationSectionComponent() {
  return (
    <QualificationSection>
      <QualificationContainer>
        <SectionTitle>公司资质</SectionTitle>
        <SectionSubtitle>Company Qualification</SectionSubtitle>
        <QualificationItems>
          {QUALIFICATIONS.map((item, idx) => (
            <QualificationItem key={idx}>
              <QualificationIconPlaceholder>
                <img src="/assets/about/i-0.png" />
              </QualificationIconPlaceholder>
              <QualificationTitle>{item.title1}</QualificationTitle>
              <QualificationTitle>{item.title2}</QualificationTitle>
              <QualificationSubtitle>{item.subtitle}</QualificationSubtitle>
            </QualificationItem>
          ))}
        </QualificationItems>
      </QualificationContainer>
    </QualificationSection>
  );
}
